<!--suppress TypeScriptUnresolvedFunction, AngularUndefinedBinding, AngularUndefinedTag -->
<app-first-time-request-devices-permission-guide
  (skipRequestPermission)="hideRequestPermissionGuideLayout()"
  [audioOnly]="data.audioOnly === true"
  *ngIf="currentPrompt === prompts.FIRST_TIME_JOINING"
></app-first-time-request-devices-permission-guide>

<app-steps-guide
  *ngIf="currentPrompt === prompts.HELPER_GUIDE"
  [loading]="guideLoading"
  [guide]="helperGuide"
  [hasRelatedError]="hasRelatedError$ | async"
  [errorMsg]="errorMsg$ | async"
  (closeModal)="onCloseGuide()"
  (done)="onDoneGuide()"
>
</app-steps-guide>

<div class="join-call-container" [hidden]="currentPrompt !== prompts.JOIN_CALL">
  <div class="mobile-header mobile">
    <span class="title">
      {{ data.isStartCall ? ('Ready to start?' | translate) : ('Ready to join?' | translate) }}
    </span>

    <app-pencil-button
      *ngIf="(isChildModeActive$ | async) === false"
      class="pencil-button close-button"
      (clickEvent)="closeDialog()"
      [icon]="'close'"
      [iconConfig]="{ type: 'mat-icon' }"
    >
    </app-pencil-button>
  </div>
  <div class="join-call-panel">
    <div class="left-part">
      <div
        class="device-video-preview-container"
        [ngClass]="{
          'audio-detected': isAudioActive$ | async
        }"
      >
        <div
          class="speaking-indicator"
          [appTooltip]="'Audio detected from your mic' | translate"
          [appTooltipDisabled]="isTouchDevice"
          [appTooltipPlacement]="'top-center'"
          [appTooltipArrow]="'bottom'"
        >
          <div class="audio-visualizer">
            <div class="bar bar-1"></div>
            <div class="bar bar-2"></div>
            <div class="bar bar-3"></div>
          </div>
        </div>
        <span class="camera-status-position camera-status-text" *ngIf="camState.isGettingStream">{{
          'Camera starting...' | translate
        }}</span>
        <div
          class="camera-status-position"
          *ngIf="!camState.hasError && !camState.isGettingStream && !camState.state"
        >
          <span class="camera-status-text">{{ 'Camera off' | translate }}</span>
          <span class="camera-status-tip-text" [ngClass]="screenType.MOBILE">{{
            'Turn on your camera below.' | translate
          }}</span>
        </div>

        <div
          class="camera-status-position"
          *ngIf="camState.hasError && !camState.isGettingStream && !camState.state"
        >
          <div class="cam-troubleshoot-area">
            <span [innerHTML]="cameraErrorMessage$ | async" class="camera-status-text"> </span>

            <span
              class="camera-status-tip-text"
              *ngIf="camState.errorType === deviceErrorType.GET_USER_MEDIA_TIMEOUT"
              >{{
                'Please reload this page. If issues persist, please restart your browser.'
                  | translate
              }}
              <a [attr.href]="intercomArticles.GetPreviewStreamsStuckJoinCallPanel" target="_blank">
                {{ 'Need help?' | translate }}
              </a></span
            >
            <span
              class="camera-status-tip-text"
              *ngIf="camState.hasError && camState.errorType === deviceErrorType.DEFAULT_ERROR"
              >{{ 'Please adjust your audio and video to resolve this.' | translate }}</span
            >
          </div>
        </div>
        <video
          #deviceVideoPreview
          id="deviceVideoPreview"
          [hidden]="(camState.hasError && !camState.state) || camState.isGettingStream"
          muted
          playsinline
          autoplay="autoplay"
        ></video>
        <div
          class="device-preview-controls-container"
          [ngClass]="{
            'no-input-camera-device-preview-controls-container':
              camState.hasError && camState.errorType === deviceErrorType.NO_INPUT_DETECTED
          }"
        >
          <div
            class="mic-hover-area"
            (mouseover)="
              showMicNoInputPopUp =
                micState.hasError && micState.errorType === deviceErrorType.NO_INPUT_DETECTED
            "
            (mouseleave)="showMicNoInputPopUp = false"
          >
            <div
              *ngIf="
                (uiService.isMobile | async) === false &&
                showMicNoInputPopUp &&
                micState.hasError &&
                micState.errorType === deviceErrorType.NO_INPUT_DETECTED
              "
              class="no-mic-input-container"
            >
              <app-no-input-from-mic
                (settingsNoMicInput)="openDeviceModal()"
                (troubleshootNoMicInput)="openHelperGuide(guides.NO_INPUT)"
              >
              </app-no-input-from-mic>
            </div>
            <app-mic-button
              class="mic-button"
              data-name="start-call-button-toggle-mic"
              [shouldTriggerSpeakingIndicator]="false"
              [disableTooltipOnTouch]="true"
              [config]="{ theme: ColorScheme.DARK }"
              [showChevron]="false"
            ></app-mic-button>
          </div>

          <app-cam-button
            class="camera-button"
            data-name="start-call-button-toggle-camera"
            [disableTooltipOnTouch]="true"
            [config]="{ theme: ColorScheme.DARK }"
            [showChevron]="false"
          ></app-cam-button>

          <app-virtual-background-button
            *ngIf="virtualBackgroundSupported"
            class="virtual-background-wrapper"
            [isEnabled]="virtualBackgroundEnabled"
            [isMobile]="isMobile"
            [isRealDesktop]="isRealDesktop"
            (backgroundClick)="handleVirtualBackgroundButtonClick($event)"
          ></app-virtual-background-button>

          <app-pencil-button
            class="apps-more-menu"
            [matMenuTriggerFor]="actionsMenu"
            #menuTrigger="matMenuTrigger"
            [class.menu-opened]="menuTrigger.menuOpen"
            [appTooltip]="'More' | translate"
            [appTooltipDisabled]="isTouchDevice"
            [appTooltipArrow]="'bottom'"
            [appTooltipPanelClass]="'join-call-advanced-settings-tooltip'"
            [iconConfig]="{ outlined: true, type: 'material-icon' }"
            [icon]="'more_vert'"
            [theme]="'primary-dark'"
          >
          </app-pencil-button>

          <mat-menu
            [yPosition]="'above'"
            [xPosition]="'before'"
            #actionsMenu="matMenu"
            class="more-actions-menu-join-call"
          >
            <button
              (click)="$event.stopPropagation(); musicModeToggle.toggle()"
              mat-menu-item
              *ngIf="musicModeFeatureFlag"
            >
              <span class="item-text-content">
                <mat-icon class="icn">music_note</mat-icon>
                <span>{{ 'Music mode' | translate }}</span>
              </span>
              <mat-slide-toggle
                (click)="$event.stopPropagation()"
                #musicModeToggle
                [(ngModel)]="enableMusicMode"
              ></mat-slide-toggle>
            </button>

            <button
              *ngIf="isNoiseCancellationSupported"
              (click)="$event.stopPropagation(); noiseCancellationToggle.toggle()"
              mat-menu-item
            >
              <span class="item-text-content">
                <mat-icon class="icn">hearing_disabled</mat-icon>
                <span>{{ 'Noise cancellation' | translate }}</span>
              </span>
              <mat-slide-toggle
                (click)="$event.stopPropagation()"
                [(ngModel)]="enableNoiseCancellation"
                #noiseCancellationToggle
              ></mat-slide-toggle>
            </button>
          </mat-menu>
        </div>
      </div>

      <div class="devices-select-container">
        <ng-template
          #joinCallSpeakerTriggerTpl
          let-selectorOpen="selectorOpen"
          let-mobileClick="mobileClick"
        >
          <ng-container *ngIf="speakerTrigger$ | async as trigger">
            <app-pencil-select-trigger
              [icon]="trigger.icon"
              [label]="trigger.label"
              [hasError]="trigger.hasError"
              [disabled]="trigger.disabled"
              [isOpen]="selectorOpen"
              (triggerClick)="mobileClick ? trigger.clickAction() : trigger.troubleshootAction?.()"
            ></app-pencil-select-trigger>
          </ng-container>
        </ng-template>
        <ng-template
          #joinCallMicTriggerTpl
          let-selectorOpen="selectorOpen"
          let-mobileClick="mobileClick"
        >
          <ng-container *ngIf="micTrigger$ | async as trigger">
            <app-pencil-select-trigger
              [icon]="trigger.icon"
              [label]="trigger.label"
              [hasError]="trigger.hasError"
              [disabled]="trigger.disabled"
              [isOpen]="selectorOpen"
              (triggerClick)="mobileClick ? trigger.clickAction() : trigger.troubleshootAction?.()"
            ></app-pencil-select-trigger>
          </ng-container>
        </ng-template>
        <ng-template
          #joinCallCamTriggerTpl
          let-selectorOpen="selectorOpen"
          let-mobileClick="mobileClick"
        >
          <ng-container *ngIf="camTrigger$ | async as trigger">
            <app-pencil-select-trigger
              [icon]="trigger.icon"
              [label]="trigger.label"
              [hasError]="trigger.hasError"
              [disabled]="trigger.disabled"
              [isOpen]="selectorOpen"
              (triggerClick)="mobileClick ? trigger.clickAction() : trigger.troubleshootAction?.()"
            ></app-pencil-select-trigger>
          </ng-container>
        </ng-template>
        <ng-template #joinCallMicLevelBarsTpl>
          <ng-container *ngIf="{ activeBars: (micActiveBars$ | async) ?? 0 } as micLevel">
            <div class="mic-level-row">
              <app-pencil-icon
                class="mic-level-icon"
                [name]="'mic'"
                [type]="IconTypes.svgIcon"
              ></app-pencil-icon>
              <div class="mic-level-bars" aria-hidden="true">
                <span
                  class="mic-level-bar"
                  *ngFor="let i of micLevelBars"
                  [class.active]="i < micLevel.activeBars"
                ></span>
              </div>
            </div>
          </ng-container>
        </ng-template>
        <ng-template #joinCallSpeakerTestSpeakerContentTpl let-stopPropagation="stopPropagation">
          <span
            class="test-speaker-text"
            [class.playing]="isPlayingSpeakerTest$ | async"
            (click)="stopPropagation && $event.stopPropagation()"
          >
            <app-pencil-icon
              [name]="(isPlayingSpeakerTest$ | async) ? 'speaker_audio_green' : 'speaker_audio'"
              [type]="IconTypes.svgIcon"
              class="test-speaker-icon"
            ></app-pencil-icon>
            {{
              (isPlayingSpeakerTest$ | async)
                ? ('Playing sound...' | translate)
                : ('Test Speakers' | translate)
            }}
          </span>
        </ng-template>
        <ng-template #joinCallDeviceMenuItemTpl let-sheet="sheet" let-option="option">
          <app-pencil-menu-item
            class="device-option-menu-item"
            [class.join-call-device-sheet-item]="sheet"
            [label]="option.label"
            [renderCheckIcon]="option.selected"
            [selected]="option.selected"
            (clickEvent)="sheet && selectDeviceFromBottomSheet(option.kind, option.deviceId)"
          ></app-pencil-menu-item>
        </ng-template>
        <ng-container
          *ngIf="(uiService.isMobile | async) === false; else joinCallMobileDeviceSelectors"
        >
          <div class="device-container">
            <ng-container *ngIf="speakerTrigger$ | async as trigger">
              <mat-select
                [ngClass]="{
                  'has-error': trigger.hasError,
                  'device-select': true,
                  'device-select-open': speakerSelectOpen,
                  'menu-item-select': true
                }"
                [(value)]="selectedSpeakerMatSelect"
                [panelClass]="['custom-mat-select-panel', 'join-call-modal-mat-select-panel']"
                [disableOptionCentering]="true"
                (selectionChange)="
                  setSpeakerPreview($event.value); syncSpeakerSelection($event.value)
                "
                (openedChange)="speakerSelectOpen = $event"
                [disabled]="trigger.disabled"
                data-name="video-audio-options-change-speakers"
              >
                <mat-select-trigger class="select-trigger">
                  <ng-container
                    *ngTemplateOutlet="
                      joinCallSpeakerTriggerTpl;
                      context: { selectorOpen: speakerSelectOpen }
                    "
                  ></ng-container>
                </mat-select-trigger>
                <mat-option [value]="LOADING" disabled selected hidden>
                  {{ 'Loading...' | translate }}
                </mat-option>
                <ng-container>
                  <mat-option [value]="'default'" *ngIf="devices?.speakers.length === 0">
                    <ng-container
                      *ngTemplateOutlet="
                        joinCallDeviceMenuItemTpl;
                        context: {
                          sheet: false,
                          option: {
                            label: ('System Default' | translate),
                            deviceId: 'default',
                            kind: DeviceKind.Speaker,
                            selected: selectedSpeakerMatSelect === 'default'
                          }
                        }
                      "
                    ></ng-container>
                  </mat-option>
                  <mat-option [value]="speaker.deviceId" *ngFor="let speaker of devices?.speakers">
                    <ng-container
                      *ngTemplateOutlet="
                        joinCallDeviceMenuItemTpl;
                        context: {
                          sheet: false,
                          option: {
                            label: speaker.label,
                            deviceId: speaker.deviceId,
                            kind: DeviceKind.Speaker,
                            selected: selectedSpeakerMatSelect === speaker.deviceId
                          }
                        }
                      "
                    ></ng-container>
                  </mat-option>
                  <!-- Speaker Test Option -->
                  <mat-option
                    [value]="TEST_SPEAKER"
                    (mousedown)="handleTestSpeakerClick($event)"
                    (click)="$event.stopPropagation()"
                    class="speaker-test-option"
                    *ngIf="(speakerShowError$ | async) === false"
                  >
                    <ng-container
                      *ngTemplateOutlet="
                        joinCallSpeakerTestSpeakerContentTpl;
                        context: { stopPropagation: true }
                      "
                    ></ng-container>
                  </mat-option>
                </ng-container>
              </mat-select>
            </ng-container>
          </div>

          <div class="device-container">
            <ng-container *ngIf="micTrigger$ | async as trigger">
              <mat-select
                [ngClass]="{
                  'has-error': trigger.hasError,
                  'device-select': true,
                  'device-select-open': micSelectOpen,
                  'menu-item-select': true
                }"
                [(value)]="selectedMicMatSelect"
                (selectionChange)="setMicPreview($event.value); syncMicSelection($event.value)"
                (openedChange)="micSelectOpen = $event"
                [disabled]="trigger.disabled"
                [panelClass]="['custom-mat-select-panel', 'join-call-modal-mat-select-panel']"
                [disableOptionCentering]="true"
                data-name="video-audio-options-change-mic"
              >
                <mat-select-trigger class="select-trigger">
                  <ng-container
                    *ngTemplateOutlet="
                      joinCallMicTriggerTpl;
                      context: { selectorOpen: micSelectOpen }
                    "
                  ></ng-container>
                </mat-select-trigger>
                <mat-option [value]="LOADING" disabled selected hidden>
                  {{ 'Loading...' | translate }}
                </mat-option>
                <ng-container>
                  <mat-option [value]="mic.deviceId" *ngFor="let mic of devices?.mics">
                    <ng-container
                      *ngTemplateOutlet="
                        joinCallDeviceMenuItemTpl;
                        context: {
                          sheet: false,
                          option: {
                            label: mic.label,
                            deviceId: mic.deviceId,
                            kind: DeviceKind.Mic,
                            selected: selectedMicMatSelect === mic.deviceId
                          }
                        }
                      "
                    ></ng-container>
                  </mat-option>
                  <mat-option class="mic-level-option" disabled>
                    <ng-container *ngTemplateOutlet="joinCallMicLevelBarsTpl"></ng-container>
                  </mat-option>
                </ng-container>
              </mat-select>
            </ng-container>
          </div>

          <div class="device-container">
            <ng-container *ngIf="camTrigger$ | async as trigger">
              <mat-select
                [ngClass]="{
                  'has-error': trigger.hasError,
                  'device-select': true,
                  'device-select-open': cameraSelectOpen,
                  'menu-item-select': true
                }"
                [(value)]="selectedCamMatSelect"
                (selectionChange)="setCameraPreview($event.value); syncCamSelection($event.value)"
                (openedChange)="cameraSelectOpen = $event"
                [panelClass]="['custom-mat-select-panel', 'join-call-modal-mat-select-panel']"
                [disabled]="trigger.disabled"
                [disableOptionCentering]="true"
                data-name="video-audio-options-change-camera"
              >
                <mat-select-trigger class="select-trigger">
                  <ng-container
                    *ngTemplateOutlet="
                      joinCallCamTriggerTpl;
                      context: { selectorOpen: cameraSelectOpen }
                    "
                  ></ng-container>
                </mat-select-trigger>
                <mat-option [value]="LOADING" disabled selected hidden>
                  {{ 'Loading...' | translate }}
                </mat-option>
                <ng-container>
                  <mat-option [value]="cam.deviceId" *ngFor="let cam of devices?.cameras">
                    <ng-container
                      *ngTemplateOutlet="
                        joinCallDeviceMenuItemTpl;
                        context: {
                          sheet: false,
                          option: {
                            label: cam.label,
                            deviceId: cam.deviceId,
                            kind: DeviceKind.Camera,
                            selected: selectedCamMatSelect === cam.deviceId
                          }
                        }
                      "
                    ></ng-container>
                  </mat-option>
                </ng-container>
              </mat-select>
            </ng-container>
          </div>
        </ng-container>
        <ng-template #joinCallMobileDeviceSelectors>
          <div class="device-container" data-name="video-audio-options-change-speakers">
            <ng-container
              *ngTemplateOutlet="
                joinCallSpeakerTriggerTpl;
                context: { selectorOpen: deviceKind === DeviceKind.Speaker, mobileClick: true }
              "
            ></ng-container>
          </div>
          <div class="device-container" data-name="video-audio-options-change-mic">
            <ng-container
              *ngTemplateOutlet="
                joinCallMicTriggerTpl;
                context: { selectorOpen: deviceKind === DeviceKind.Mic, mobileClick: true }
              "
            ></ng-container>
          </div>
          <div class="device-container" data-name="video-audio-options-change-camera">
            <ng-container
              *ngTemplateOutlet="
                joinCallCamTriggerTpl;
                context: { selectorOpen: deviceKind === DeviceKind.Camera, mobileClick: true }
              "
            ></ng-container>
          </div>
        </ng-template>
      </div>
    </div>

    <div class="join-call-details-continer">
      <app-pencil-button
        *ngIf="(isChildModeActive$ | async) === false"
        class="pencil-button close-button"
        (clickEvent)="closeDialog()"
        [icon]="'close'"
        [iconConfig]="{ type: 'mat-icon' }"
      >
      </app-pencil-button>
      <span class="title text-padding-small-screen-sizes">
        {{ data.isStartCall ? ('Ready to start?' | translate) : ('Ready to join?' | translate) }}
      </span>
      <div
        class="people-in-call"
        id="people-in-call"
        *ngIf="!micState.hasError && !camState.hasError && inCallUsers.length > 0"
      >
        <app-users-presence
          [users]="inCallUsers"
          [maxUsers]="4"
          [avatarWidth]="32"
          [avatarFontSize]="16"
          [avaterTooltipPosition]="'bottom'"
          [tooltipsBackgroundColor]="'#111111'"
          [othersIconHeight]="'32px'"
          [othersIconWidth]="'32px'"
          [useShowOthersListV2]="true"
          [parentClassNameShowOthersListV2]="'people-in-call'"
        >
        </app-users-presence>
      </div>
      <ng-container
        *ngTemplateOutlet="buttonsTemplate; context: { screenType: screenType.DESKTOP }"
      >
      </ng-container>
    </div>

    <ng-container *ngTemplateOutlet="buttonsTemplate; context: { screenType: screenType.MOBILE }">
    </ng-container>
  </div>

  <ng-template #buttonsTemplate let-screenType="screenType">
    <div
      *ngFor="let hasError of [camState.hasError || micState.hasError]"
      class="confirm-buttons"
      [ngClass]="screenType"
    >
      <div class="device-error-message" *ngIf="micState.hasError || camState.hasError">
        <p>
          {{ troubleshootErrorMessage$ | async }}
        </p>
      </div>
      <div class="actions">
        <app-pencil-button
          *ngIf="hasError && !micState.isGettingStream"
          class="pencil-button troubleshoot"
          (clickEvent)="micState.hasError ? troubleshootMic() : troubleshootCam()"
          data-name="troubleshoot-join-call-button"
          [icon]="
            (applyTroubleshootPermissionStyle$ | async)
              ? 'check'
              : micState.hasError
              ? 'mic_off_with_error_white'
              : 'videocam_off_with_error_white'
          "
          [iconConfig]="{ type: 'svg-icon' }"
          [label]="
            (applyTroubleshootPermissionStyle$ | async)
              ? 'Allow access'
              : micState.hasError
              ? ('Troubleshoot mic' | translate)
              : ('Troubleshoot cam' | translate)
          "
        >
        </app-pencil-button>

        <app-pencil-button
          class="pencil-button"
          [ngClass]="{
            'join-without-error': !hasError,
            'join-with-error': hasError
          }"
          (clickEvent)="finish(CallRelatedModalActionEnum.START_JOINING_THE_CALL)"
          data-name="start-call-button-confirm"
          icon="call"
          [iconConfig]="{ type: 'mat-icon' }"
          [disabled]="micState.isGettingStream"
          [label]="
            micState.isGettingStream || camState.isGettingStream || isLoadingDevices
              ? ('Loading...' | translate)
              : data.isStartCall
              ? hasError
                ? ('Start call anyway' | translate)
                : ('Start call' | translate)
              : hasError
              ? ('Join call anyway' | translate)
              : ('Join call' | translate)
          "
        >
        </app-pencil-button>
      </div>
    </div>

    <span
      class="join-call-bottom-text"
      [ngClass]="screenType"
      *ngIf="showObserverModeNotice$ | async"
    >
      {{ 'Calls may be monitored by admins.' | translate }}
      <a class="learn-more-link" (click)="openObserverSupportLink()">
        {{ 'Learn more' | translate }}
      </a>
    </span>
  </ng-template>

  <ng-template #deviceSelectBottomSheetTpl>
    <app-pencil-bottom-sheet-container
      [title]="deviceSheetTitle"
      [colorScheme]="ColorScheme.DARK"
      (closeClicked)="dismissDeviceBottomSheet()"
    >
      <div class="join-call-device-sheet-body" [ngSwitch]="deviceKind">
        <ng-container *ngSwitchCase="DeviceKind.Speaker">
          <ng-container *ngIf="devices?.speakers.length === 0">
            <ng-container
              *ngTemplateOutlet="
                joinCallDeviceMenuItemTpl;
                context: {
                  sheet: true,
                  option: {
                    label: ('System Default' | translate),
                    deviceId: 'default',
                    kind: DeviceKind.Speaker,
                    selected: selectedSpeakerMatSelect === 'default'
                  }
                }
              "
            ></ng-container>
          </ng-container>
          <ng-container *ngFor="let speaker of devices?.speakers">
            <ng-container
              *ngTemplateOutlet="
                joinCallDeviceMenuItemTpl;
                context: {
                  sheet: true,
                  option: {
                    label: speaker.label,
                    deviceId: speaker.deviceId,
                    kind: DeviceKind.Speaker,
                    selected: selectedSpeakerMatSelect === speaker.deviceId
                  }
                }
              "
            ></ng-container>
          </ng-container>
          <div
            *ngIf="(speakerShowError$ | async) === false"
            class="join-call-device-sheet-test-speaker"
            (click)="onTestSpeakerFromBottomSheet()"
          >
            <ng-container
              *ngTemplateOutlet="
                joinCallSpeakerTestSpeakerContentTpl;
                context: { stopPropagation: false }
              "
            ></ng-container>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="DeviceKind.Mic">
          <ng-container *ngFor="let mic of devices?.mics">
            <ng-container
              *ngTemplateOutlet="
                joinCallDeviceMenuItemTpl;
                context: {
                  sheet: true,
                  option: {
                    label: mic.label,
                    deviceId: mic.deviceId,
                    kind: DeviceKind.Mic,
                    selected: selectedMicMatSelect === mic.deviceId
                  }
                }
              "
            ></ng-container>
          </ng-container>
          <div class="join-call-device-sheet-mic-level">
            <ng-container *ngTemplateOutlet="joinCallMicLevelBarsTpl"></ng-container>
          </div>
        </ng-container>
        <ng-container *ngSwitchCase="DeviceKind.Camera">
          <ng-container *ngFor="let cam of devices?.cameras">
            <ng-container
              *ngTemplateOutlet="
                joinCallDeviceMenuItemTpl;
                context: {
                  sheet: true,
                  option: {
                    label: cam.label,
                    deviceId: cam.deviceId,
                    kind: DeviceKind.Camera,
                    selected: selectedCamMatSelect === cam.deviceId
                  }
                }
              "
            ></ng-container>
          </ng-container>
        </ng-container>
      </div>
    </app-pencil-bottom-sheet-container>
  </ng-template>
</div>
